<template>
    <el-dialog title="订单备注" :visible="true" center :before-close="handleCloseDialog">
        <el-form size="small" :model="form" ref="form"  label-width="120px" class="invoice-ruleForm">
            <el-form-item label="备注信息：" prop="memo">
                <el-input v-model="form.memo" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">关闭</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
        </div>
    </el-dialog>
</template>
<script>
import OrderService from "~/services/order";
export default {
    props:{
        dialog_visible: false,
        params: null,
        show_type: '',
    },
    components:{
    },

    data() {
        return {
            form: {
                order_id: '',
                memo: '',
            },
            // rules: {
            //     memo: [
            //         {required: true,message: "请填输入订单备注",trigger: "blur"}
            //     ],
            // },
            formLabelWidth: '100px',
            loading: false
        };
    },

    created() {
        this.form = Object.assign(this.form, this.params);
    },
    
    methods:{
        handleSubmit(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    OrderService.setMemo(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message:'编辑成功',
                                type:'success'
                            });
                            this.$emit("submit", this.form);
                            this.resetFields();
                        }
                        this.loading = false;
                    }).catch((err) => {
                        console.error(err);
                        this.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },

        resetFields(){
            this.$refs['form'].resetFields();
            this.form = {
                order_id: '',
                memo: '',
            };
        },

        handleCloseDialog(){
            this.resetFields();
            this.$emit("submit", this.params);
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/dialog/memoForm.vue